import { SchemaDeSerBuilder } from "./deser"

class PreferencesAccount {
  currentAccount = ""
  privacy = false
}

export class Preferences {
  account = new PreferencesAccount()
}

const PREFERENCES_ACCOUNT_DESER = new SchemaDeSerBuilder(PreferencesAccount)
  .ofString("currentAccount")
  .ofBoolean("privacy")
  .toDeSer()

export const PREFERENCES_DESER = new SchemaDeSerBuilder(Preferences)
  .ofNested("account", PREFERENCES_ACCOUNT_DESER, PreferencesAccount)
  .toDeSer()
